var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApprovals(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4609_38136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7996 10.3984H23.1995C26.3995 10.3984 26.3995 9.39842 26.3995 8.39842C26.3995 6.39844 24.7995 6.39844 23.1995 6.39844H16.7996C15.1996 6.39844 13.5996 6.39844 13.5996 8.39842C13.5996 10.3984 15.1996 10.3984 16.7996 10.3984Z",
    fill: "#E0F3FF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4609_38136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3994 26.8008C16.3994 27.9321 16.3994 28.4978 16.7509 28.8493C17.1024 29.2008 17.668 29.2008 18.7994 29.2008H21.1994C22.3307 29.2008 22.8964 29.2008 23.2479 28.8493C23.5994 28.4978 23.5994 27.9321 23.5994 26.8008",
    stroke: "#1552E8",
    strokeWidth: 0.828566,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9994 21.9993V27.1992M19.9994 27.1992L21.5994 25.4492M19.9994 27.1992L18.3994 25.4492",
    stroke: "#1552E8",
    strokeWidth: 0.828566,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.7996 10.4H23.1995C26.3995 10.4 26.3995 8.79997 26.3995 7.19998C26.3995 4 24.7995 4 23.1995 4H16.7996C15.1996 4 13.5996 4 13.5996 7.19998C13.5996 10.4 15.1996 10.4 16.7996 10.4Z",
    stroke: "#081E54",
    strokeWidth: 0.999993,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3995 7.23438C31.7274 7.52237 34.3994 9.49036 34.3994 16.8023V26.4022C34.3994 32.8022 32.7994 36.0022 24.7995 36.0022H15.1995C7.1996 36.0022 5.59961 32.8022 5.59961 26.4022V16.8023C5.59961 9.50636 8.27159 7.52237 13.5996 7.23438",
    stroke: "#081E54",
    strokeWidth: 0.999993,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.4286,
    y1: 14.7746,
    x2: 27.5713,
    y2: 14.7746,
    stroke: "#A020FF",
    strokeWidth: 0.857137,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.4286,
    y1: 17.173,
    x2: 27.5713,
    y2: 17.173,
    stroke: "#A020FF",
    strokeWidth: 0.857137,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.4286,
    y1: 19.5753,
    x2: 27.5713,
    y2: 19.5753,
    stroke: "#A020FF",
    strokeWidth: 0.857137,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4609_38136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.9997,
    height: 39.9997,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4609_38136"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.1997,
    y: 20.8008,
    width: 9.59994,
    height: 9.59994,
    rx: 3.99997,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovals);
export default __webpack_public_path__ + "static/media/Approvals.a88fe4bff6f028cf2e61532b7c5490a6.svg";
export { ForwardRef as ReactComponent };